// Following guide from https://stackoverflow.com/a/61188946

import { createIntl, createIntlCache } from 'react-intl'

let cache
// eslint-disable-next-line import/no-mutable-exports
let intl

/**
 * Generate IntlShape object
 * @param {Object} props
 * @param {String} props.locale - User specified language
 * @param {Object} props.messages - Messages
 * @returns {Object}
 */
const generateIntl = (props) => {
  if (cache) {
    cache = null
  }

  cache = createIntlCache()

  intl = createIntl(props, cache)
  return intl
}

export { generateIntl, intl }
